<div class="scroll" id="scroll-container">
    <div class="scroll-list">
        <ng-content></ng-content>
    </div>
</div>